import cn from 'classnames'
import {FC, forwardRef, Ref} from 'react'

import {SECTION_PADDING_DESKTOP, SECTION_PADDING_MOBILE} from '@/theme/sizing'
import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE, TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

import {Container} from './Container'

type SectionProps = {
  id?: string
  backgroundColor?: string
  hasPaddingTop?: boolean
  hasPaddingBottom?: boolean
  className?: string
  hasContainer?: boolean
  hasBorderTop?: boolean
  borderColor?: string
  isHighlighted?: boolean
  ref?: Ref<HTMLElement>
  marginTop?: string
}

export const Section: FC<React.PropsWithChildren<SectionProps>> = forwardRef(
  (
    {
      id,
      backgroundColor,
      hasPaddingTop,
      hasPaddingBottom,
      className,
      hasContainer = true,
      hasBorderTop = false,
      borderColor = theme.palette.gray[200],
      isHighlighted = false,
      children,
      marginTop,
    },
    ref,
  ) => {
    return (
      <>
        <section className={cn('section', className)} id={id} ref={ref}>
          {hasContainer ? (
            <Container>
              {isHighlighted ? <div className="wrapper">{children}</div> : children}
            </Container>
          ) : (
            children
          )}
        </section>

        <style jsx>{`
          .section {
            position: relative;
            background-color: ${backgroundColor ? backgroundColor : 'transparent'};
            ${hasPaddingTop ? `padding-top: ${SECTION_PADDING_DESKTOP}` : ''};
            ${hasPaddingBottom ? `padding-bottom: ${SECTION_PADDING_DESKTOP}` : ''};
            ${hasBorderTop ? `border-top: 1px solid ${borderColor}` : ''};
            ${marginTop ? `margin-top: ${marginTop}` : ''};
          }
          .form {
            padding-top: ${theme.spacing[6]};
            padding-bottom: 200px; /* special case */
          }
          .wrapper {
            ${isHighlighted && `background-color: ${theme.palette.background.butter}`};
            border-radius: 16px;
            padding: ${SECTION_PADDING_DESKTOP} ${theme.spacing[7]};
          }
          .overflow-hidden {
            overflow: hidden;
          }
          /* clips only horizontally, unlike overflow-x: hidden, which would make the y axis scroll */
          .overflow-x-clip {
            overflow-x: clip;
          }
          @media ${TABLET_SCREENSIZE} {
            .form {
              padding-bottom: 180px; /* special case */
            }
            .wrapper {
              padding: ${SECTION_PADDING_DESKTOP} ${theme.spacing[5]};
            }
          }
          @media ${MOBILE_SCREENSIZE} {
            .section {
              ${hasPaddingTop ? `padding-top: ${SECTION_PADDING_MOBILE}` : ''};
              ${hasPaddingBottom ? `padding-bottom: ${SECTION_PADDING_MOBILE}` : ''};
            }
            .form {
              padding-top: ${theme.spacing[4]};
              padding-bottom: 0;
            }
            .wrapper {
              padding: ${SECTION_PADDING_MOBILE} ${theme.spacing[3]};
            }
          }
        `}</style>
      </>
    )
  },
)
